<template>
  <div class="scroll view">
    <div v-if="loading" style="align-self: center; margin-bottom: 1rem;">
      loading...
    </div>
    <div v-if="!loading && !anomalies.length">
      No results.
    </div>
    <div id="confirmed">
      <div v-if="anomalies && anomalies.length > 0" class="confirmed-list" >
        <div
          v-for="anomaly of sortedAnomalies"
          :key="anomaly.id"
          style="display: flex; flex-direction: column; width: 45%; flex-wrap: wrap; padding: .0rem .5rem;"
          >
          <owal-banner style="display: flex; flex-direction: row; flex-wrap: wrap;">
            <div class="anomaly-banner__left-hand-container">
              <div style="" class="anomaly-banner__category-container">
                <strong style="padding-right: .25rem;">{{anomaly.type}}</strong>
                <div class="anomaly-banner__description-subtext">at  {{anomaly.description}}</div>
              </div>
              <div style="display: flex; flex-direction: row;">
                <div style="padding-right: .5rem;">start: </div>
                <div> {{stringFromTimestamp(anomaly.detection_start)}}</div>
              </div>
              <div style="display: flex; flex-direction: row;">
                <div style="padding-right: 1rem;">end: </div>
                <div>{{stringFromTimestamp(anomaly.detection_end)}}</div>
              </div>
              <div style="display: flex; flex-direction: row;">
                <div style="padding-right: 1rem;">created at: </div>
                <div>{{stringFromTimestamp(anomaly.created_at)}}</div>
              </div>
            </div>
            <div class="anomaly-banner__right-hand-container">
              <owal-button :title="'view clip'"/>
            </div>
          </owal-banner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAnomalyForFrontendFaceUUID } from '@/libraries/api/faces'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { OwalBanner, OwalButton } from '@/libraries/owal-ui'

export default {
  name: 'AnomalyList',
  components: {
    OwalBanner,
    OwalButton,
  },
  props: {
    frontendFaceUUID: {
      type: String,
      default: undefined,
    },
  },
  data () {
    return {
      anomalies: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      currentDomainUUID: 'currentDomainUUID',
    }),
    sortedAnomalies () {
      const ret = [ ...this.anomalies ].sort((a, b) => {
        console.log(b.startUNIX - a.startUNIX)
        if (!b.startUNIX) {
          return -1
        } else if (!a.startUNIX) {
          return +1
        }
        return b.startUNIX - a.startUNIX
      })
      return ret
    },
  },
  methods: {
    stringFromTimestamp (ts) {
      return moment.utc(ts, 'YYYY-MM-DD kk:mm:ss').format('MMM Do, hh:mm:ss a') || ts
    },
  },
  mounted () {
    this.loading = true
    getAnomalyForFrontendFaceUUID(this.frontendFaceUUID, this.currentDomainUUID).then(res => res.data).then(function (data) {
      if (!data.ok) {
        console.log(data.err)
        return
      }
      this.anomalies = data.results.map(det => {
        det.startUNIX = moment.utc(det.detection_start).valueOf()
        return det
      })
      this.loading = false
    }.bind(this)).catch((err) => {
      console.log(err)
      this.loadingConfirmed = false
    })
  },
}
</script>

<style scoped>

@media only screen and (min-width: 930px) and (max-width: 930px) {
  /* button should float below content when screen is med/small */
  .anomaly-banner__right-hand-container {
    width: 100%;
    padding-bottom: 1.5rem;
    padding-right: 0rem;
    justify-content: center!important;
  }

  .anomaly-banner__description-subtext {
    width: 100%;
  }

  .anomaly-banner__category-container {
    flex-wrap: wrap;
  }
  .anomaly-banner__left-hand-container {
    padding-left: 0rem;

  }
}

.anomaly-banner__category-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.anomaly-banner__left-hand-container {
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  padding-left: 1rem;
  padding-top: 1rem;
  flex-shrink: 0;
  flex-grow: 0;
}

.anomaly-banner__right-hand-container {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: flex-end;
  flex-grow: 1;
  padding-right: 1rem;
}

.scroll.view {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
  padding-bottom: 3rem;
}

@media only screen and (min-width: 768px) {
  .confirmed-list {
    justify-content: space-between;
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .confirmed-list {
    justify-content: center;
  }
}

#confirmed {
  height: 100%;
}

.confirmed-list {
  display: flex;
  flex-wrap: wrap;
}

</style>
